import React from "react";
import styles from "../styles/ReviewModal.module.css";

const ReviewModal = ({ reviews, onClose }) => {
  const renderStars = (rating) => {
    return (
      <div className={styles.stars}>
        {[1, 2, 3, 4, 5].map(star => (
          <span key={star} className={star <= rating ? styles.starFilled : styles.starEmpty}>
            ★
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>All Customer Reviews</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className={styles.modalBody}>
          {reviews.map((review) => (
            <div key={review.id} className={styles.reviewItem}>
              <div className={styles.reviewHeader}>
                <div>
                  <span className={styles.verifiedBadge}>✓ Verified Purchase</span>
                  <strong className={styles.customerName}>{review.customer_name}</strong>
                  <span className={styles.reviewDays}>
                    {review.reviewDaysFlag} day{review.reviewDaysFlag !== 1 ? 's' : ''}
                  </span>
                </div>
                {renderStars(review.rating)}
              </div>
              <p className={styles.reviewText}>{review.review_text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;
